export default "__VITE_ASSET__CXBU1aMw__"